import { ChangeDetectorRef, Component, Inject, OnInit, signal } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { interval, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { bounceIn } from "src/app/animations/custom.animation";
import { TrackedEventsService } from "src/app/services/tracked-events.service";
import { JackpotSuccessComponent } from "../../../components/jackpot-success/jackpot-success.component";
import { SyndicateRepositoryService } from "../../syndicate/syndicate-repository.service";
import { IonicModule } from "@ionic/angular";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";
import { ClarityService } from "src/app/services/clarity.service";

@Component({
    selector: "app-trigger-filled",
    templateUrl: "./triggers.component.html",
    styleUrls: ["./triggers.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [
        IonicModule,
        MatProgressSpinner,
        MatIcon,
        TranslatePipe,
    ],
})
export class TriggersComponent implements OnInit {
  triggers: any[] = [];
  jackpotTrigger;
  notDeactivating = true;
  spinnerAnimation: boolean;
  progressBar: number = 10;
  timer$: any;
  sub: any;
  proceed = true;
  spinnerForDecline = false;
  translatedToastMsg: any;
  translatedToastMsgSignal = signal<any>([])
  selectedLanguage: string = "en";
  selectedLanguageSignal = signal<string>("en")
  constructor(
    private dialog: MatDialog,
    private matBottomSheet: MatBottomSheetRef<TriggersComponent>,
    private syndicateService: SyndicateRepositoryService,
    private snackBar: MySnackBarService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private cdRef: ChangeDetectorRef,
    private trackedEventsService: TrackedEventsService,
    public translate: TranslateService,
    private authService: AuthService,
    private clarityService: ClarityService
  ) {
    // Subscribe to selectedlanguage$ observable
    this.authService.selectedlanguage$.subscribe({
      next: (l: string) => {
        this.selectedLanguageSignal.set(l || "en")
        this.selectedLanguage = this.selectedLanguageSignal();
        translate.use(l ? l : "en");
      },
      error: (err) => {
        return err;
      }
    });


    this.authService.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsgSignal.set(msg?.static_messages_pwa)
      this.translatedToastMsg = this.translatedToastMsgSignal();
    })
  }

  ngOnInit() {
    this.syndicateService.getTriggerData(this.data?.triggerPath).subscribe((val: any) => {
      this.jackpotTrigger = val;
    });

    try {
      // Subscribe to getUserJacktpotTrigger() observable
      this.syndicateService.getUserJacktpotTrigger().subscribe({
        next: (trigger: Data[]) => {
          // Iterate through the triggers
          trigger.forEach((data) => {
            // Check if the trigger is applicable to the current product and is active
            if (
              data?.current_jackpot?.path?.substring(data?.current_jackpot?.path?.indexOf("/") + 1) === this.data?.productName &&
              data?.status
            ) {
              // Construct trigger data object
              let triggerData = {
                jackpot_trigger: data.jackpot_trigger,
                lines: data.trigger_active_count,
                id: data.sql_trigger_id,
              };
              // Add triggerData to the triggers array
              this.triggers.push(triggerData);
            }
          });
        },
        error: (err) => {
          return err;
        }
      });

    } catch (e) {

    }
  }

  openJackpotSuccessPopup() {
    const confirmationDialog = this.dialog.open(JackpotSuccessComponent, {
      panelClass: "jackpot-success-dialog",
      backdropClass: "cashout-back-drop-color",
    });

    // Subscribe to afterClosed() observable of confirmationDialog
    confirmationDialog.afterClosed().subscribe({
      next: async (dialogResponse: boolean) => {
        // Handle the dialog response
        this.trackedEventsService.openAnimation();
      },
      error: (err) => {
        return err;
      }
    });

  }

  backToProduct() {
    this.matBottomSheet.dismiss();
  }

  createTrigger() {
    let isUpdatedCelebration = false;
    let jackpotTrigger = {
      lines: this.jackpotTrigger?.lines,
      jackpot: this.jackpotTrigger?.jackpot,
      price: this.jackpotTrigger?.price,
      free_jackpot: this.jackpotTrigger?.free_jackpot ?? false,
      alternate_free_jackpot:
        this.jackpotTrigger?.alternate_free_jackpot ?? false,
      free_offer_id: this.jackpotTrigger?.free_offer_id ?? 0,
      offer_link_id: this.jackpotTrigger?.offer_link_id,
      offer_id: this.jackpotTrigger.offer_id,
    };

    this.syndicateService
      .activateTrigger(jackpotTrigger)
      .pipe(
        catchError((error) => {
          // RB #24242 fix
          return throwError(error);
        })
      )
      ?.subscribe(
        (res: any) => {
          if (res?.status === "rejected") {
            this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
            return;
          }
          this.progressBar = 100;
          this.sub?.unsubscribe();
          this.cdRef.detectChanges();
          if (res?.status === "fail") {
            //this.snackBar.openSnackBar(res.message ? res.message : "Process failed", "", "Error", "Error");
            /* const msg = this.translatedToastMsg?.["1056"]?.[this.selectedLanguage];
          this.authService.showToast(res.message ? res.message : msg ? msg : "Process failed", "Error", ""); */
            this.authService.getConstantsMsg("1056").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Process failed",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
          } else {
            this.clarityService.event("jackpot_trigger_activated");
            this.clarityService.setTag("product_type", "jackpot_trigger");
            this.matBottomSheet.dismiss();
            setTimeout(() => {
              this.openJackpotSuccessPopup();
            }, 1000);
          }

          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            setTimeout(() => {
              this.proceed = true;
              this.cdRef.detectChanges();
            }, 2000);
          }, 300);
        },
        (err) => {
          return err;
        }
      );

    this.trackedEventsService.listOfEvents$.subscribe(
      (d) => {
        d.some((f) => f.id === "join_trigger_jackpot")
          ? this.trackedEventsService.updateTrackedUserEvent("join_trigger_jackpot")
          : null;
      },
      (err) => {
        return (err);
      }
    );

    this.trackedEventsService.listOfEvents$.subscribe(
      (d) => {
        d.map((data: any) => {
          if (data.id === "join_trigger_jackpot" && !isUpdatedCelebration) {
            this.trackedEventsService.updateCelebration(data);
            isUpdatedCelebration = true;
          }
        });
      },
      (err) => {
        return (err);
      }
    );
  }

  startSpinner() {
    this.cdRef.detectChanges();
    this.spinnerAnimation = true;
    this.progressBar = 10;
    this.timer$ = interval(20);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
      },
      (err) => {
        return (err);
      }
    );
  }

  deactivateTrigger(id) {
    let jackpotTrigger = {
      lines: this.jackpotTrigger?.lines,
      jackpot: this.jackpotTrigger?.jackpot,
      price: this.jackpotTrigger?.price,
      free_jackpot: this.jackpotTrigger?.free_jackpot ?? false,
      alternate_free_jackpot:
        this.jackpotTrigger?.alternate_free_jackpot ?? false,
      free_offer_id: this.jackpotTrigger?.free_offer_id ?? 0,
      offer_link_id: this.jackpotTrigger?.offer_link_id,
      offer_id: this.jackpotTrigger.offer_id,
    };
    this.spinnerForDecline = true;
    this.notDeactivating = false;
    this.syndicateService
      .deactivateTrigger(jackpotTrigger)
      .pipe(
        catchError((error) => {
          // RB #24226 fix
          return throwError(`An error occurred while deactivating trigger ${error}`);
        })
      )
      .subscribe(
        (res) => {
          if (res?.status === "rejected") {
            this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
            return;
          }
          this.spinnerForDecline = false;
          this.backToProduct();
          if (res?.status === "fail") {
            // this.snackBar.openSnackBar(res.message ? res.message : "Process failed", "", "Error", "Error");
            /* const msg = this.translatedToastMsg?.["1056"]?.[this.selectedLanguage];
          this.authService.showToast(res.message ? res.message : msg ? msg : "Process failed", "Error", ""); */
            this.authService.getConstantsMsg("1056").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Process failed",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
          } else {
            /* this.snackBar.openSnackBar(
            res.message ? res.message : "Process has been successfuly done",
            "",
            "Success",
            "Success"
          ); */
            /* const msg = this.translatedToastMsg?.["1048"]?.[this.selectedLanguage];
          this.authService.showToast(res.message ? res.message : msg ? msg : "Process has been successfuly done", "Success", ""); */
            this.authService.getConstantsMsg("1048").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Process has been successfuly done",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
          }
        },
        (err) => {
          return err;
        }
      );
  }
}
